export default __webpack_public_path__ + "static/Graphik-BoldItalic-Web-4842bd61b7882f5f363ecd492c88232d.woff";